import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { createFeedbackState, applyFeedback } from "../engine/effects.js";

/**
 * FeedbackNode
 * ------------
 * Feeds the previous frame back into the current one with adjustable decay.
 * Creates motion trails, echo effects, and ghosting.
 */
export class FeedbackNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Feedback";

    this.properties = {
      decay: 0.85,
      offsetX: 0,
      offsetY: 0,
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    addDrivableSlider(this, "Decay", "decay", 0.85, 0, 0.99, 0.01);
    addDrivableSlider(this, "Offset X", "offsetX", 0, -50, 50, 1);
    addDrivableSlider(this, "Offset Y", "offsetY", 0, -50, 50, 1);

    finalizeDrivableSliders(this, 1);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");
    this._feedbackState = createFeedbackState();

    this.size = [200, 110];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyFeedback(ctx, w, h, this._feedbackState, {
      decay: this.properties.decay,
      offsetX: this.properties.offsetX,
      offsetY: this.properties.offsetY,
    });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/Feedback", FeedbackNode);
